var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"data-cy":"rectangle-container"}},[_c('div',{staticClass:"line-chart",style:({ bottom: _vm.hasComparison })},[_c(_vm.chartComponent,{directives:[{name:"show",rawName:"v-show",value:(_vm.sparklineData.length),expression:"sparklineData.length"}],key:_vm.componentKey,tag:"component",attrs:{"config":_vm.getChartConfig()}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }